module.exports = __webpack_public_path__ + "img/strategy_mw_grey.68a77736.svg";